// Formato de dinero MXN (es-MX). Función pura — shared/lib (§6.2 de la arquitectura).
const MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });

export function formatMXN(value: number): string {
    return MXN.format(value);
}

/**
 * Monto abreviado de las barras densas (`fmtMoneyShort` del mock): `$4.2M`, `$26.9K` o `$840`.
 * Sin la rama de millones el total de un mes de tienda sale `$4180.0K`, más largo que el número.
 */
export function formatShortMXN(value: number): string {
    const abs = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `${sign}$${(abs / 1_000).toFixed(1)}K`;
    return `${sign}$${String(Math.round(abs))}`;
}

/** Los `*Cents` del wire son enteros; a pesos se dividen entre 100 antes de formatear. */
export function formatMoneyCents(cents: number): string {
    return MXN.format(cents / 100);
}
